import { useEffect } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import type { Props } from '../types/PageLoadMarkProps.ts';

const PageLoadMarkComponent = ({ name }: Props) => {
	useEffect(() => {
		addUFOCustomMark(name);
	}, [name]);

	return null;
};

export const PageLoadMark = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(PageLoadMarkComponent);
